import React, { useEffect } from "react";
import Context from "../../../../context";

import { ICreateStudent } from "../../../../types/student.interface";
import {
  CustomButton2,
  CustomIcon,
  CustomModal,
  TableHeader,
  TableLoading,
} from "../../../../components";

import "./index.scss";
import values from "../../../../values";
import utils from "../../../../utils";
import { useQuery } from "react-query";
import api from "../../../../api";
import { INVOICES_STATUS } from "../../../../values/dropdownItems";
import PayModal from "./components/PayModal";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

const INVOICES = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const {
    showModal,
    setShowModal,
    createFunction,
    getInvoices,
    selectedService,
    isLoading,
  } = React.useContext(Context.ServiceScreen);

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  // useEffect(() => {
  //   getInvoices!(selectedService?._id).then((res: any) => setAllInvoice(res));
  // }, []);

  // console.log(allInvoice?.result);

  const getData = useQuery(
    [values.useQueryKeys.getInvoices, selectedService?._id],
    () => api.get.common.findInvoices({ serviceId: selectedService?._id }),
    { enabled: showModal === "SERVICE_INVOICE" }
  );
  const { status, data } = getData;

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();

  return (
    <section id="invoice-table">
      <CustomModal
        onClose={() => {
          setShowModal!("NONE");
          // setFormData({});
          // setStep(1);
        }}
        open={
          showModal === "SERVICE_INVOICE" || showModal === "PAY" ? true : false
        }
        minWidth={"40vw"}
      >
        <h6>{t("factors")}</h6>
        <table>
          <TableHeader headers={values.tableHeaders.INVOICE_HEADERS} />
          {status === "loading" && <TableLoading />}
          <tbody>
            {status === "success" &&
              data?.result?.factorsList?.map((invoice: any, index: number) => {
                return (
                  <>
                    {
                      <tr key={`parent-${index}`}>
                        <td
                          className="pointer"
                          // onClick={() => onClick(parent)}
                        >
                          {index + 1}
                        </td>
                        {/* actions */}
                        <td>
                          {utils.convertNumberToPrice(invoice?.price)}{" "}
                          {t("toman")}
                        </td>
                        <td>
                          {
                            INVOICES_STATUS.find(
                              (item) => item.value === invoice?.status
                            )?.name
                          }
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: invoice?.oldSubscriptionDate,
                            format: "jYYYY/jMM/jDD",
                          })}
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: invoice?.newSubscriptionDate,
                            format: "jYYYY/jMM/jDD",
                          })}
                        </td>
                        {/* <td>
                          <div className="table-actions-buttons">
                            <CustomIcon
                              icon="fa fa-credit-card"
                              hoverTitle="پرداخت"
                              
                            />
    
                          </div>
                        </td> */}
                      </tr>
                    }
                  </>
                );
              })}
          </tbody>
        </table>
        {/* <div className="pay-button">
          {userType !== "ADMIN" && (
            <CustomButton2
              title={"پرداخت"}
              onClick={() => setShowModal!("PAY")}
            />
          )}
          <PayModal price={data?.result?.price} />
        </div> */}
      </CustomModal>
    </section>
  );
};

export default INVOICES;
